module.exports = __webpack_public_path__ + "img/ziyuan.61f4d208.png";